import {
  useAssetsFilter,
  useGenericFilter,
  type FilterableProperty,
  type UsePersistedBlotterTable,
} from '@talos/kyoko';
import { useMemo, useState } from 'react';
import type { TradeSettlementFilter } from '../types';

interface UseUnsettledTransactionsFilterParams {
  persistedBlotterTable: UsePersistedBlotterTable;
}

export function useUnsettledTransactionsFilter({ persistedBlotterTable }: UseUnsettledTransactionsFilterParams) {
  const [initialFilter] = useState<TradeSettlementFilter>(
    () => (persistedBlotterTable.initialState?.filter as TradeSettlementFilter) ?? {}
  );

  const assetsFilter = useAssetsFilter();

  const filterableProperties = useMemo(
    () =>
      [{ ...assetsFilter, clearUnsupportedSelectionsOnInit: false }] satisfies FilterableProperty<
        keyof TradeSettlementFilter
      >[],
    [assetsFilter]
  );

  const { filter, filterBuilderProps } = useGenericFilter<TradeSettlementFilter>(filterableProperties, {
    initialFilter,
    onFilterChanged: persistedBlotterTable.onFilterChanged,
  });

  return {
    filterBuilderProps,
    filter,
    filterableProperties,
  };
}

const colIDToFilterBuilderKeyMap = {
  LegAsset: 'Symbols',
  'BaseLeg.Asset': 'Symbols',
  'QuoteLeg.Asset': 'Symbols',
} as const satisfies Partial<Record<string, keyof TradeSettlementFilter>>;

export function colIDToFilterBuilderKey(id: string): keyof TradeSettlementFilter | undefined {
  return colIDToFilterBuilderKeyMap[id as keyof typeof colIDToFilterBuilderKeyMap];
}
